import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import colors from '@/styles/colors';
import ModalLayout from '@/layouts/ModalLayout';

const SectionTitleStyle = css`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 8px;
`;

export const Dialog = styled(ModalLayout)`
  width: 507px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${rgba(colors.primaryTint, 0.1)};
  border-radius: 8px;
  padding: 20px 35px;
  margin-bottom: 24px;

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 4px;
    text-align: center;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
  }
`;

export const ScoreSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  h2 {
    ${SectionTitleStyle}
  }
`;

export const CommentSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;

  h2 {
    ${SectionTitleStyle}
  }
`;

export const CommentInput = styled.textarea`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${colors.secondaryLite};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;

  :focus {
    border: 1px solid ${colors.primaryTint};
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  button + button {
    margin-left: 16px;
  }
`;
